<template>
  <div class="box">
    <div class="section">
      <!-- 顶部导航栏 -->
      <div class="header">
        <el-row class="navigation" type="flex" justify="center">
          <el-col :xs="0" :sm="2" :md="4" :lg="6" :xl="8" />
          <el-col>
            <div class="d-flex ai-center jc-between">
              <span class="d-flex ai-center">
                <img class="m-1" src="@/assets/logo.png" alt="" width="45" />
                <span class="ml-2 websitetitle">
                  <div>留言舆情管理系统</div>
                </span>
              </span>
              <span class="d-flex ai-center jc-end title"> </span>
            </div>
          </el-col>
          <el-col :xs="0" :sm="2" :md="4" :lg="6" :xl="8" />
        </el-row>
      </div>
      <!-- 主体 -->
      <el-row class="login_bg">

        <!-- <router-view /> -->
        <div class="login-container">
          <h1>用户登录</h1>
          <router-view />
          <!-- <form>
            <div class="input-group">
              <input type="text" placeholder="用户名/邮箱" required />
            </div>
            <div class="input-group">
              <input type="password" placeholder="密码" required />
            </div>
            <button type="submit">登 录</button>
          </form>
          <div class="footer">
            <p>还没有账号？<a href="#">立即注册</a></p>
          </div> -->
        </div>
      </el-row>
    </div>
    <!-- 页脚 -->
    <div class="footer">
      <el-row type="flex" justify="center">
        <el-col :lg="19" :xs="24" class="foot-text">
          <!-- <span class="m-2 text-red fs-md">留言舆情管理系统</span> -->
          <span class="m-2 text-grey hidden-sm-and-down fs-md">
            盛威科贸有限公司 湘ICP备2024051925号-1
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  created() {
    // document.title = "舆情管理系统";
    // var token = window.sessionStorage.getItem("token");
    // var userInfo = window.sessionStorage.getItem("userInfo");

    // if (token && userInfo && token.length > 0 && userInfo.length > 0) {
    //   var data = JSON.parse(userInfo);
    //   this.$router.push({ name: "MainFrame" });
    // }
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang='less' scoped>
.box {
  width: 100vw;
  height: 100vh;
  background-size: cover;
}

.navigation {
  width: 100%;
  z-index: 1000;
  // height: 60px;
  background-color: #333744;
}

.title {
  color: white;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Arial", sans-serif;
}

.login_bg {
  height: 100vh;
  background-color: red;
  background: url("/images/bg.png") no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.login-container {
  width: 400px;
  margin-right: 10%;
  padding: 40px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.input-group {
  margin-bottom: 20px;
}

input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border 0.3s;
}

input:focus {
  border-color: #4285f4;
  outline: none;
}

button {
  width: 100%;
  padding: 12px;
  background: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

button:hover {
  background: #3367d6;
}

.footer {
  margin-top: 20px;
  text-align: center;
  color: #666;
}

a {
  color: #4285f4;
  text-decoration: none;
}
</style>
